import React from 'react';
import { ShieldCheck, CheckCheck, Move, Clock, Settings, Users } from 'lucide-react';
import feature from "../assests/images/feature.jpg";
import "../App.css";

const WhyChooseUs = () => {
  const features = [
    { 
      icon: ShieldCheck,
      title: 'Industry-Leading Expertise',
      color: '#FFA916'
    },
    { 
      icon: CheckCheck, 
      title: 'End-to-End ERP Systems',
      color: '#FFA916'
    },
    { 
      icon: Move, 
      title: 'Comprehensive Solutions',
      color: '#FFA916'
    },
    { 
      icon: Settings, 
      title: 'Scalable Architecture',
      color: '#FFA916'
    },
    { 
      icon: Users, 
      title: 'Dedicated Support',
      color: '#FFA916'
    },
    { 
      icon: Clock, 
      title: '24/7 Expert Support',
      color: '#FFA916'
    }
  ];

  return (
    <div 
      className="container-fluid overflow-hidden my-4 px-lg-0 wow fadeIn" 
      data-wow-delay="0.1s"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      <div 
        className="container-xxl feature px-lg-0" 
        style={{ 
          backgroundColor: '#024A59',
          borderRadius: '20px',
          boxShadow: '0 15px 40px rgba(0,0,0,0.15)'
        }}
      >
        <div className="row g-0 mx-lg-0">
          {/* Left Content Section */}
          <div 
            className="col-lg-6 feature-text py-4 wow fadeInLeft" 
            data-wow-delay="0.2s"
            style={{ padding: '40px 30px', position: 'relative', zIndex: 1 }}
          >
            <div className="p-lg-4 ps-lg-0">
             
              <h1 
                className="text-white mb-3" 
                style={{
                  fontSize: '2rem',
                  lineHeight: 1.3,
                  fontWeight: '700',
                  textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}
              >
                Transforming Businesses Through Innovation
              </h1>
              
              <div className="row g-3">
                {features.map((feature, index) => {
                  const Icon = feature.icon;
                  return (
                    <div 
                      className="col-12 col-md-6" 
                      key={index}
                      style={{
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-3px)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'none'}
                    >
                      <div 
                        className="d-flex align-items-center p-2"
                        style={{
                          borderRadius: '10px',
                          background: 'linear-gradient(145deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))',
                          backdropFilter: 'blur(5px)'
                        }}
                      >
                        <div 
                          className="d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle"
                          style={{ 
                            width: '50px', 
                            height: '50px',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            border: `2px solid ${feature.color}`,
                            boxShadow: `0 4px 15px ${feature.color}40`
                          }}
                        >
                          <Icon 
                            color={feature.color} 
                            size={22}
                            strokeWidth={1.8}
                          />
                        </div>
                        <div className="ms-2">
                          <h5 
                            className="mb-1" 
                            style={{
                              color: feature.color,
                              fontSize: '0.95rem',
                              fontWeight: '600',
                              letterSpacing: '0.2px'
                            }}
                          >
                            {feature.title}
                          </h5>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Right Image Section */}
          <div 
            className="col-lg-6 pe-lg-0 wow fadeInRight" 
            data-wow-delay="0.4s"
            style={{ minHeight: '380px', position: 'relative' }}
          >
            <div 
              className="position-relative h-100"
              style={{
                background: `linear-gradient(45deg, rgba(2,74,89,0.4), rgba(2,74,89,0.2)), url(${feature})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center 30%',
                borderTopRightRadius: '20px',
                borderBottomRightRadius: '20px'
              }}
            >
              <div 
                style={{
                  position: 'absolute',
                  bottom: '25px',
                  left: '25px',
                  right: '25px',
                  backgroundColor: 'rgba(255,255,255,0.95)',
                  padding: '20px',
                  borderRadius: '12px',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
                }}
              >
                <h4 
                  style={{ 
                    color: '#024A59',
                    marginBottom: '12px',
                    fontWeight: '700',
                    fontSize: '1.3rem'
                  }}
                >
                  Our Commitment
                </h4>
                <p 
                  className="mb-0"
                  style={{ 
                    color: '#444',
                    lineHeight: 1.5,
                    fontSize: '0.95rem'
                  }}
                >
                  Strategic ERP solutions driving operational excellence and sustainable growth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
